import { FaPlus } from "react-icons/fa6";
import ContentContainer from "../ContentContainer";
import TitleTextSection from "../TitelTextSection";
import InfoSummeryBand from "./InfoSummeryBand";
import InfoSummeryPost from "./InfoSummeryPost";
import InfoSummeryEvent from "./InfoSummeryEvent";

const UserProfileListItems = ({ itemType, items, title, createNewUrl }) => {
  const displayedItems =
    itemType === "event"
      ? [...items].sort((a, b) => {
          const aDate = new Date(a?.date).getTime();
          const bDate = new Date(b?.date).getTime();
          if (Number.isNaN(aDate) || Number.isNaN(bDate)) return 0;
          return bDate - aDate;
        })
      : [...items].reverse();

  return (
    <ContentContainer>
      <div className="flex justify-between items-center mb-2">
        <TitleTextSection title={title} />
        <a href={createNewUrl}>
          <button className="btn bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full flex flex-nowrap text-nowrap font-bold uppercase tracking-wider text-xs px-5 py-3 shadow-[0_4px_15px_rgba(0,71,255,0.3)] transition-transform duration-300 hover:scale-105">
            <FaPlus size={14} className="mr-1.5" />
            <span className="hidden sm:inline">Skapa nytt</span>
            <span className="sm:hidden inline">Nytt</span>
          </button>
        </a>
      </div>

      {itemType === "band" && (
        <div className="hidden sm:grid grid-cols-8 px-4 mb-1">
          <p className="col-span-5 text-[10px] font-bold uppercase tracking-wider text-stone-500">
            Namn
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Offentlig
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Ändra
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Besök
          </p>
        </div>
      )}
      {itemType === "post" && (
        <div className="hidden sm:grid grid-cols-8 px-4 mb-1">
          <p className="col-span-3 text-[10px] font-bold uppercase tracking-wider text-stone-500">
            Titel
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Av
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Typ
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Offentlig
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Ändra
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Besök
          </p>
        </div>
      )}
      {itemType === "event" && (
        <div className="hidden sm:grid grid-cols-7 px-4 mb-1">
          <p className="col-span-3 text-[10px] font-bold uppercase tracking-wider text-stone-500">
            Namn
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Datum
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Av
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Ändra
          </p>
          <p className="col-span-1 text-[10px] font-bold uppercase tracking-wider text-stone-500 text-center">
            Besök
          </p>
        </div>
      )}

      <div className="divide-y divide-base-content/10">
        {items && items.length > 0 ? (
          displayedItems.map((item, index) => (
            <div key={index}>
              {itemType === "band" && <InfoSummeryBand band={item} />}
              {itemType === "post" && <InfoSummeryPost post={item} />}
              {itemType === "event" && <InfoSummeryEvent event={item} />}
            </div>
          ))
        ) : (
          <p className="py-4 text-base-content/50 text-sm">Inga skapade</p>
        )}
      </div>
    </ContentContainer>
  );
};

export default UserProfileListItems;
